document.addEventListener('DOMContentLoaded', function() {
   function setHeaderHeight(){
    var siteHeader = document.querySelector('.site-header');
    if (!siteHeader) return;
    var h = siteHeader.offsetHeight;
    document.documentElement.style.setProperty('--header-height', h + 'px');
  }

  // run on DOM ready + load
  document.addEventListener('DOMContentLoaded', setHeaderHeight);
  window.addEventListener('load', setHeaderHeight);

  // debounce resize
  var resizeTimer;
  window.addEventListener('resize', function(){
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(setHeaderHeight, 100);
  });

  // observe header size changes (images, dynamic content)
  if (window.ResizeObserver) {
    var header = document.querySelector('.site-header');
    if (header) {
      var ro = new ResizeObserver(setHeaderHeight);
      ro.observe(header);
    }
  }


 var btn = document.getElementById('menu-button');
  var overlay = document.getElementById('mobile-menu-overlay');
  if (!btn || !overlay) return;

  // ensure overlay top (in case JS calculates header height)
  function setOverlayTop() {
    var headerHeight = getComputedStyle(document.documentElement).getPropertyValue('--header-height') || null;
    if (!headerHeight) {
      // try compute and set CSS variable if missing
      var header = document.querySelector('.site-header');
      if (header) {
        document.documentElement.style.setProperty('--header-height', header.offsetHeight + 'px');
      }
    }
  }
  setOverlayTop();

  btn.setAttribute('aria-expanded', 'false');

  function openMenu() {
    overlay.classList.add('is-open');
    document.body.classList.add('mobile-menu-open');
    btn.setAttribute('aria-expanded', 'true');
    // focus first link inside overlay
    var first = overlay.querySelector('a, button, [tabindex]:not([tabindex="-1"])');
    (first || overlay).focus();
  }

  function closeMenu() {
    overlay.classList.remove('is-open');
    document.body.classList.remove('mobile-menu-open');
    btn.setAttribute('aria-expanded', 'false');
    btn.focus();
  }

  btn.addEventListener('click', function (e) {
    e.preventDefault();
    if (overlay.classList.contains('is-open')) {
      closeMenu();
    } else {
      openMenu();
    }
  });

  overlay.addEventListener('click', function (e) {
    if (e.target === overlay) closeMenu();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && overlay.classList.contains('is-open')) closeMenu();
  });

  // update overlay top on resize (so it always expands from header bottom)
  window.addEventListener('resize', function () {
    setOverlayTop();
  });

});